import React from 'react'
import {string, bool} from "prop-types";

function getHeaderMenuHeight() {
  const header = document.getElementById('header');
  if (header) {
    return header.getBoundingClientRect().bottom;
  }
  return 0;
}

function adaptMenu() {
  let nodes = document.querySelectorAll(".scrollbar-container li[role=menuitem]>label span:nth-child(2)");
  nodes.forEach(node => {
    node.innerHTML = node.innerHTML.replaceAll('/', '/<wbr>');
  });
}

function adaptTag(tag) {
  let html = document.querySelector('body');
  let walker = document.createTreeWalker(html, NodeFilter.SHOW_TEXT);
  let node;
  while ((node = walker.nextNode())) {
    let regexp = new RegExp(String.raw`\[` + tag + String.raw`\]`, 'g');
    if (regexp.test(node.nodeValue)) {
      console.log(node)
      node.nodeValue = node.nodeValue.replace(regexp, '');
      let span = document.createElement('span');
      span.className = tag;
      node.after(span);
    }
  }
}

function adaptTags() {
  adaptTag("beta");
  adaptTag("new");
}

Api.propTypes = {
  openapi: string.isRequired,
  external: bool,
};

export function Api({external = false, ...props}) {

  const OPENAPI_BASE = process.env.GATSBY_OPENAPI_BASE_URL
  const VERSION = process.env.GATSBY_APP_VERSION
  const containerRef = React.useRef(null)

  React.useEffect(() => {
    const container = containerRef.current
    const specUrl = (external ? OPENAPI_BASE + props.openapi : props.openapi) + `?v=${VERSION}`;
    fetch(specUrl)
      .then(res => res.json())
      .then(json => {
        const updated = {...json}
        if (updated.info?.["x-logo"]?.url) {
          updated.info["x-logo"].url = "/images/logo.png"
        }
        window.Redoc.init(
          updated,
          {
            hideLoading: true,
            sortEnumValuesAlphabetically: true,
            menuToggle: true,
            suppressWarnings: true,
            requiredPropsFirst: true,
            showWebhookVerb: false,
            scrollYOffset: getHeaderMenuHeight,
          },
          containerRef.current,
          () => {
            adaptMenu();
            adaptTags();
          }
        )
      })

    return () => {
      if (container) {
        container.innerHTML = ''
      }
    }
  }, [OPENAPI_BASE, VERSION, props.openapi, external])

  return <div ref={containerRef} />
}